// extracted by mini-css-extract-plugin
export default {"container":"DateTimeLabel_container__epvK4","timezoneContainer":"DateTimeLabel_timezoneContainer__JhUwH"};